module.exports = __webpack_public_path__ + "img/parlez-nous.994cc65a.jpg";